// Master data for Coal varieties — used on Products page
export const COAL_VARIETIES = [
    {
        slug: "anthracite",
        name: "Anthracite",
        tag: "Hard / High Carbon",
        origin: ["Russia", "USA", "Vietnam"],
        gcv: "7,500 – 8,200 kcal/kg",
        carbon: "86 – 98%",
        ash: "6 – 12%",
        moisture: "2 – 6%",
        sulfur: "0.5 – 1.0%",
        volatile: "< 10%",
        description:
            "The highest rank of coal. Dense, glossy black with exceptional energy density and low impurities. Burns hot with very little smoke — premium fuel for metallurgy, sintering and high-grade heating.",
        uses: ["Sinter Plants", "Ferro Alloy", "PCI for Blast Furnace", "Residential Heating"],
    },
    {
        slug: "bituminous-coking",
        name: "Bituminous — Coking (Metallurgical)",
        tag: "Steel Grade",
        origin: ["Australia", "USA", "Russia"],
        gcv: "6,800 – 7,800 kcal/kg",
        carbon: "75 – 90%",
        ash: "8 – 12%",
        moisture: "5 – 10%",
        sulfur: "0.5 – 1.2%",
        volatile: "20 – 35%",
        description:
            "Strongly caking, low-ash coal that fuses into a porous, strong coke when heated. The non-negotiable feedstock for blast-furnace steelmaking. Premium hard coking and semi-soft variants available.",
        uses: ["Coke Ovens", "Integrated Steel Plants", "Foundries"],
    },
    {
        slug: "bituminous-thermal",
        name: "Bituminous — Thermal (Steam Coal)",
        tag: "Power Grade",
        origin: ["Indonesia", "South Africa", "Australia", "Russia"],
        gcv: "5,500 – 6,800 kcal/kg",
        carbon: "70 – 86%",
        ash: "8 – 16%",
        moisture: "8 – 15%",
        sulfur: "0.4 – 1.0%",
        volatile: "25 – 40%",
        description:
            "Workhorse steam coal for thermal power. Calibrated for pulverised-coal boilers — consistent CV, balanced moisture and predictable ash chemistry.",
        uses: ["Power Plants", "Cement Kilns", "Captive Power"],
    },
    {
        slug: "sub-bituminous",
        name: "Sub-Bituminous Coal",
        tag: "Mid Rank",
        origin: ["Indonesia", "USA", "Indonesia (Kalimantan)"],
        gcv: "4,200 – 5,500 kcal/kg",
        carbon: "65 – 75%",
        ash: "4 – 10%",
        moisture: "15 – 30%",
        sulfur: "0.2 – 0.6%",
        volatile: "30 – 45%",
        description:
            "Dull, brownish-black coal with lower carbon and lower sulfur. Excellent fit for circulating fluidised bed (CFB) boilers, brick kilns and cement industries seeking low-sulfur fuel.",
        uses: ["CFB Boilers", "Brick Kilns", "Cement Industry", "Textile Boilers"],
    },
    {
        slug: "lignite",
        name: "Lignite (Brown Coal)",
        tag: "Low Rank",
        origin: ["Indonesia", "Russia", "Domestic India"],
        gcv: "2,800 – 4,200 kcal/kg",
        carbon: "55 – 70%",
        ash: "5 – 15%",
        moisture: "30 – 45%",
        sulfur: "0.3 – 1.5%",
        volatile: "35 – 50%",
        description:
            "Soft, brown coal with high moisture and high volatile matter. Locally mined and imported variants supplied for utilities operating fluidised bed plants and chemical-grade applications.",
        uses: ["FBC Boilers", "Lignite-fired Power Plants", "Briquetting"],
    },
    {
        slug: "pet-coke",
        name: "Petroleum Coke (Pet Coke)",
        tag: "Refinery Byproduct",
        origin: ["USA", "Saudi Arabia", "Venezuela"],
        gcv: "8,000 – 8,500 kcal/kg",
        carbon: "85 – 95%",
        ash: "0.2 – 1.0%",
        moisture: "1 – 4%",
        sulfur: "3.0 – 7.5%",
        volatile: "8 – 14%",
        description:
            "Carbon-rich solid residue from oil refining. Extreme calorific value with minimal ash — preferred fuel for cement kilns under stringent CPCB norms.",
        uses: ["Cement Kilns", "Lime Kilns", "Calcination", "Carbon Anodes"],
    },
    {
        slug: "indonesian-steam-coal",
        name: "Indonesian Steam Coal (GAR 4200–6300)",
        tag: "Origin Grade",
        origin: ["Indonesia"],
        gcv: "4,200 – 6,300 GAR kcal/kg",
        carbon: "60 – 78%",
        ash: "4 – 8%",
        moisture: "12 – 28%",
        sulfur: "0.3 – 0.8%",
        volatile: "35 – 42%",
        description:
            "India's most-imported thermal coal: clean-burning, low ash, low sulfur, sized FOB Kalimantan to CIF Indian east-coast ports.",
        uses: ["Power Plants", "Cement", "Sponge Iron"],
    },
    {
        slug: "south-african-rb",
        name: "South African RB1 / RB2 / RB3",
        tag: "Benchmark Coal",
        origin: ["South Africa (Richards Bay)"],
        gcv: "5,500 – 6,500 NAR kcal/kg",
        carbon: "70 – 82%",
        ash: "12 – 17%",
        moisture: "8 – 12%",
        sulfur: "0.6 – 1.2%",
        volatile: "22 – 28%",
        description:
            "Globally benchmarked Richards Bay coal grades. Consistent specifications, ideal for pulverised-coal boilers and large utility procurement.",
        uses: ["Utility Power", "Industrial Boilers"],
    },
    {
        slug: "us-coal",
        name: "USA Coal (Appalachian / Illinois Basin)",
        tag: "High CV",
        origin: ["United States"],
        gcv: "6,200 – 7,200 kcal/kg",
        carbon: "72 – 86%",
        ash: "8 – 14%",
        moisture: "5 – 10%",
        sulfur: "0.8 – 2.5%",
        volatile: "28 – 38%",
        description:
            "High-CV bituminous coals from Appalachian & Illinois basins. Supplied to sponge iron, steel and power sectors needing strong calorific consistency.",
        uses: ["Sponge Iron", "Steel", "Power"],
    },
    {
        slug: "russian-coal",
        name: "Russian Coal (Kuzbass)",
        tag: "Cold Climate Origin",
        origin: ["Russia"],
        gcv: "5,800 – 6,800 kcal/kg",
        carbon: "72 – 84%",
        ash: "10 – 16%",
        moisture: "8 – 12%",
        sulfur: "0.3 – 0.6%",
        volatile: "24 – 32%",
        description:
            "Kuzbass-origin coals known for low sulfur and strong calorific value. Versatile across power, cement, and metallurgical applications.",
        uses: ["Power", "Cement", "PCI"],
    },
    {
        slug: "australian-coal",
        name: "Australian Coal (NSW / Queensland)",
        tag: "Premium Grade",
        origin: ["Australia"],
        gcv: "6,000 – 6,700 NAR kcal/kg",
        carbon: "74 – 84%",
        ash: "12 – 15%",
        moisture: "8 – 11%",
        sulfur: "0.5 – 0.8%",
        volatile: "24 – 30%",
        description:
            "Premium Newcastle / Hunter Valley thermal and Queensland coking coals. Tight specification windows trusted by tier-1 utilities.",
        uses: ["Utility Power", "Coke Plants"],
    },
    {
        slug: "coke-breeze",
        name: "Coke Breeze & Met Coke",
        tag: "Sized Coke",
        origin: ["China", "India"],
        gcv: "6,500 – 7,200 kcal/kg",
        carbon: "84 – 90%",
        ash: "10 – 14%",
        moisture: "1 – 4%",
        sulfur: "0.6 – 0.9%",
        volatile: "1 – 3%",
        description:
            "Crushed/screened coke supplied to sinter plants, foundries and ferro-alloy industries. Available as nut coke, pearl coke, and breeze fractions.",
        uses: ["Sinter Plants", "Ferro Alloys", "Foundries"],
    },
];

export const INDUSTRIES = [
    {
        name: "Steel & Sponge Iron",
        kicker: "Coking & PCI Grades",
        description:
            "Hard coking coal, semi-soft coking, PCI and metallurgical coke — the backbone of every blast furnace and DRI plant we serve.",
        coalTypes: ["Coking Coal", "Met Coke", "Anthracite (PCI)"],
    },
    {
        name: "Thermal Power",
        kicker: "Steam Coal",
        description:
            "Bituminous and sub-bituminous steam coal blended to specification — GCV, ash and moisture controlled to suit your boiler.",
        coalTypes: ["Indonesian GAR 4200–6300", "RB1/RB2", "Australian Thermal"],
    },
    {
        name: "Cement",
        kicker: "High CV, Low Ash Fuels",
        description:
            "Pet coke, anthracite and high-CV imported coal feed kilns and pre-calciners with predictable performance.",
        coalTypes: ["Pet Coke", "Anthracite", "South African Coal"],
    },
    {
        name: "Brick Kilns",
        kicker: "Bulk Combustion",
        description:
            "Cost-effective sub-bituminous and Indian-grade coal in 0–25 mm sizing for fixed and zigzag kilns across North India.",
        coalTypes: ["USA Coal", "Indonesian Coal", "Sub-Bituminous", "Indian Steam Coal"],
    },
    {
        name: "Textile & Paper",
        kicker: "FBC Boilers",
        description:
            "Low-sulfur Indonesian and lignite blends formulated for FBC / AFBC boilers in textile, paper and pulp mills.",
        coalTypes: ["Indonesian GAR 4200", "Lignite"],
    },
    {
        name: "Chemical & Fertilizer",
        kicker: "Process Steam",
        description:
            "Stable, low-impurity coal grades for captive power and process steam in chemical and fertiliser plants.",
        coalTypes: ["Sub-Bituminous", "Russian Coal"],
    },
];

export const COUNTRIES = [
    { code: "ID", name: "Indonesia", role: "Steam Coal Hub", ports: "Samarinda · Banjarmasin · Bontang" },
    { code: "ZA", name: "South Africa", role: "Benchmark RB Grades", ports: "Richards Bay (RBCT)" },
    { code: "AU", name: "Australia", role: "Premium & Coking", ports: "Newcastle · Gladstone · Dalrymple Bay" },
    { code: "US", name: "USA", role: "High-CV Bituminous", ports: "Hampton Roads · New Orleans" },
    { code: "RU", name: "Russia", role: "Low-Sulfur Kuzbass", ports: "Vostochny · Murmansk · Taman" },
];

export const STATS = [
    { value: "12+", label: "Years in Trade" },
    { value: "1.2M+", label: "Tonnes Handled" },
    { value: "5", label: "Sourcing Countries" },
    { value: "150+", label: "B2B Clients" },
];
